export const kaufland = {
  clientId: "Client Key",
  clientSecret: "Secret Key",
  clientIdHelp:
    "You can find the Client Key in the Kaufland Seller Portal under Settings > API (https://sellerportal.kaufland.de/settings/api).",
  clientSecretHelp:
    "The Secret Key can be found in the Kaufland Seller Portal under Settings > API (https://sellerportal.kaufland.de/settings/api).",
  storefront: "Storefront",
  storefrontHelp: "Select the Kaufland storefront (country) for this integration."
};
